import { FileText, Globe, BookOpen } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { SourceFilter } from './types';
import React from 'react';

// Matches the icon shown for each source kind in the "Add Sources" menu (add-sources-menu.tsx) —
// the Knowledge table's row icon should look like the same source, not a differently-styled one.
// No JSX here: this file is `.ts`, not `.tsx` (there's a same-named, unused `.tsx` duplicate
// alongside it — Vite's default resolver picks `.ts` first, so this is the file that's live).
const GoogleIcon = ({ className }: { className?: string }) =>
  React.createElement('img', { src: '/assets/brand/google-mono.svg', alt: '', className });

export const SOURCE_TYPE_ICONS: Record<string, LucideIcon | React.ComponentType<{ className?: string }>> = {
  LINK: Globe,
  ARTICLE: BookOpen,
  FILE: FileText,
  INTEGRATION: GoogleIcon
};

export const SOURCE_TYPE_LABELS: Record<string, string> = {
  LINK: 'Link',
  ARTICLE: 'Article',
  FILE: 'File',
  INTEGRATION: 'Integration'
};

export const SOURCE_FILTERS: SourceFilter[] = [
  { label: 'All', value: 'all' },
  { label: 'Documents', value: 'FILE' },
  { label: 'Links', value: 'LINK' },
  { label: 'Articles', value: 'ARTICLE' },
  { label: 'Google', value: 'INTEGRATION' }
];

// Maps a SOP's `workflowStatus` (WorkflowConversionStatus) to the "Workflow Status" badge
// shown in the Sources > SOP's table, matching the Figma status legend.
export const WORKFLOW_STATUS_CONFIG: Record<string, { label: string; textColor: string; bgColor: string }> = {
  // What a draft's protocol is doing, in words a reviewer acts on; readable at 12px.
  none: { label: 'Not published', textColor: 'text-gray-900', bgColor: 'bg-gray-100' },
  generating: { label: 'Building protocol', textColor: 'text-amber-700', bgColor: 'bg-amber-50' },
  created: { label: 'Protocol built', textColor: 'text-blue-700', bgColor: 'bg-blue-50' },
  failed: { label: 'Build failed', textColor: 'text-red-700', bgColor: 'bg-red-50' }
};

/** What happens to a document added "for a protocol" — said wherever one is added. */
export const FOR_PROTOCOL_NOTE =
  'It moves to the Protocols page as a draft to review, generated into a protocol with the same structure as one drafted from tickets.';
